import type { ELanguage } from '../languageHelper';

import { type ITextBase, oftenUsedTranslations } from './oftenUsed';

export interface IOnboardingTexts extends ITextBase {
    overviewTitle: string;
    overviewSubtitle: string;
    agentOverviewMessage: string;
    validationIncompleteTitle: string;
    firstNameRequired: string;
    lastNameRequired: string;
    shortDescriptionRequired: string;
    skillsRequired: string;
    topSkills: string;
    skills: string;
    certificates: string;
    roles: string;
    noCertificatesSelected: string;
    noRolesSelected: string;
    backToEdit: string;
    completeOnboarding: string;
    added: string;
    aiAnalysis: string;
    certificate: string;
    role: string;
    other: string;
    junior: string;
    midLevel: string;
    senior: string;
    expert: string;
    agentCompletionMessage: string;
    welcomeToTeam: string;
    onboardingCompleted: string;
    profileCreatedNotification: string;
    onboardingResult: string;
    superPowers: string;
    teamLeaderNotified: string;
    teamLeaderNotificationDescription: string;
    recommendedNextSteps: string;
    completeProfile: string;
    completeProfileDescription: string;
    toProfile: string;
    meetTeam: string;
    meetTeamDescription: string;
    viewTeam: string;
    exploreDashboard: string;
    exploreDashboardDescription: string;
    toDashboard: string;
    adjustSettings: string;
    adjustSettingsDescription: string;
    settings: string;
    successInNewRole: string;
}

type ILangData = {
    [lang in ELanguage]: IOnboardingTexts;
};

export const onboardingTexts: ILangData = {
    th: {
        oftenUsed: oftenUsedTranslations.th,
        overviewTitle: 'ภาพรวมการปฐมนิเทศ',
        overviewSubtitle: 'ตรวจสอบข้อมูลของคุณก่อนเสร็จสิ้นกระบวนการปฐมนิเทศ',
        agentOverviewMessage:
            'สมบูรณ์แบบ! นี่คือภาพรวมของข้อมูลทั้งหมดของคุณ กรุณาตรวจสอบทุกอย่างอย่างรอบคอบก่อนที่เราจะส่งโปรไฟล์ของคุณไปยังหัวหน้าทีมของคุณ',
        validationIncompleteTitle: 'กรุณากรอกข้อมูลต่อไปนี้ให้ครบถ้วน:',
        firstNameRequired: 'ชื่อจริงจำเป็นต้องกรอก',
        lastNameRequired: 'นามสกุลจำเป็นต้องกรอก',
        shortDescriptionRequired: 'คำอธิบายสั้นจำเป็นต้องกรอก',
        skillsRequired: 'ควรเลือกทักษะอย่างน้อยหนึ่งรายการ',
        topSkills: 'ทักษะชั้นนำ',
        skills: 'ทักษะ',
        certificates: 'ใบรับรอง',
        roles: 'บทบาท',
        noCertificatesSelected: 'ไม่ได้เลือกใบรับรอง',
        noRolesSelected: 'ไม่ได้เลือกบทบาท',
        backToEdit: 'กลับไปแก้ไข',
        completeOnboarding: 'เสร็จสิ้นการปฐมนิเทศ',
        added: 'เพิ่มแล้ว',
        aiAnalysis: 'การวิเคราะห์ AI',
        certificate: 'ใบรับรอง',
        role: 'บทบาท',
        other: 'อื่นๆ',
        junior: 'มือใหม่',
        midLevel: 'ระดับกลาง',
        senior: 'อาวุโส',
        expert: 'ผู้เชี่ยวชาญ',
        agentCompletionMessage:
            'ยินดีด้วย! คุณได้เสร็จสิ้นการปฐมนิเทศเรียบร้อยแล้ว โปรไฟล์ของคุณถูกสร้างและหัวหน้าทีมของคุณได้รับการแจ้งเตือน ยินดีต้อนรับเข้าทีม!',
        welcomeToTeam: 'ยินดีต้อนรับเข้าทีม!',
        onboardingCompleted: 'เสร็จสิ้นการปฐมนิเทศเรียบร้อยแล้ว',
        profileCreatedNotification:
            'โปรไฟล์ของคุณถูกสร้างและหัวหน้าทีมของคุณได้รับการแจ้งเกี่ยวกับความสำเร็จของคุณ คุณสามารถใช้ฟังก์ชันทั้งหมดของ Skill-App ได้แล้ว',
        onboardingResult: 'ผลการปฐมนิเทศของคุณ',
        superPowers: 'พลังพิเศษ',
        teamLeaderNotified: 'แจ้งหัวหน้าทีมแล้ว',
        teamLeaderNotificationDescription:
            'หัวหน้าทีมของคุณได้รับการแจ้งเกี่ยวกับความสำเร็จของการปฐมนิเทศของคุณและสามารถเข้าถึงโปรไฟล์ที่สมบูรณ์ของคุณได้',
        recommendedNextSteps: 'ขั้นตอนถัดไปที่แนะนำ',
        completeProfile: 'เติมข้อมูลโปรไฟล์',
        completeProfileDescription: 'เพิ่มรายละเอียดเพิ่มเติมในโปรไฟล์ของคุณ',
        toProfile: 'ไปยังโปรไฟล์',
        meetTeam: 'รู้จักทีม',
        meetTeamDescription: 'ค้นพบเพื่อนร่วมงานและทักษะของพวกเขา',
        viewTeam: 'ดูทีม',
        exploreDashboard: 'สำรวจแดชบอร์ด',
        exploreDashboardDescription: 'ใช้ฟังก์ชันทั้งหมดของ Skill-App',
        toDashboard: 'ไปยังแดชบอร์ด',
        adjustSettings: 'ปรับการตั้งค่า',
        adjustSettingsDescription: 'ปรับแต่งประสบการณ์การใช้แอปของคุณ',
        settings: 'การตั้งค่า',
        successInNewRole: 'ขอให้ประสบความสำเร็จในบทบาทใหม่ของคุณ!',
    },
    en: {
        oftenUsed: oftenUsedTranslations.en,
        overviewTitle: 'Onboarding Overview',
        overviewSubtitle: 'Review your information before completing the onboarding process.',
        agentOverviewMessage:
            'Perfect! Here is an overview of all your information. Please review everything carefully before we send your profile to your team leader.',
        validationIncompleteTitle: 'Please complete the following information:',
        firstNameRequired: 'First name is required',
        lastNameRequired: 'Last name is required',
        shortDescriptionRequired: 'Short description is required',
        skillsRequired: 'At least one skill should be selected',
        topSkills: 'Top Skills',
        skills: 'Skills',
        certificates: 'Certificates',
        roles: 'Roles',
        noCertificatesSelected: 'No certificates selected',
        noRolesSelected: 'No roles selected',
        backToEdit: 'Back to Edit',
        completeOnboarding: 'Complete Onboarding',
        added: 'Added',
        aiAnalysis: 'AI Analysis',
        certificate: 'Certificate',
        role: 'Role',
        other: 'Other',
        junior: 'Junior',
        midLevel: 'Mid-Level',
        senior: 'Senior',
        expert: 'Expert',
        agentCompletionMessage:
            'Congratulations! You have successfully completed the onboarding. Your profile has been created and your team leader has been notified. Welcome to the team!',
        welcomeToTeam: 'Welcome to the Team!',
        onboardingCompleted: 'Onboarding Successfully Completed',
        profileCreatedNotification:
            'Your profile has been created and your team leader has been informed about your successful completion. You can now use all features of the Skill-App.',
        onboardingResult: 'Your Onboarding Result',
        superPowers: 'SuperPowers',
        teamLeaderNotified: 'Team Leader Notified',
        teamLeaderNotificationDescription:
            'Your team leader has been informed about your successful onboarding completion and has access to your complete profile.',
        recommendedNextSteps: 'Recommended Next Steps',
        completeProfile: 'Complete Profile',
        completeProfileDescription: 'Add more details to your profile',
        toProfile: 'To Profile',
        meetTeam: 'Meet Team',
        meetTeamDescription: 'Discover your colleagues and their skills',
        viewTeam: 'View Team',
        exploreDashboard: 'Explore Dashboard',
        exploreDashboardDescription: 'Use all features of the Skill-App',
        toDashboard: 'To Dashboard',
        adjustSettings: 'Adjust Settings',
        adjustSettingsDescription: 'Personalize your app experience',
        settings: 'Settings',
        successInNewRole: 'Good luck in your new role!',
    },
    de: {
        oftenUsed: oftenUsedTranslations.de,
        overviewTitle: 'Onboarding-Übersicht',
        overviewSubtitle: 'Überprüfen Sie Ihre Angaben vor dem Abschluss des Onboarding-Prozesses.',
        agentOverviewMessage:
            'Perfekt! Hier ist eine Übersicht aller Ihrer Angaben. Bitte prüfen Sie alles noch einmal sorgfältig, bevor wir Ihr Profil an Ihren Teamleiter senden.',
        validationIncompleteTitle: 'Bitte vervollständigen Sie folgende Angaben:',
        firstNameRequired: 'Vorname ist erforderlich',
        lastNameRequired: 'Nachname ist erforderlich',
        shortDescriptionRequired: 'Kurzbeschreibung ist erforderlich',
        skillsRequired: 'Mindestens eine Fähigkeit sollte ausgewählt werden',
        topSkills: 'Top Fähigkeiten',
        skills: 'Fähigkeiten',
        certificates: 'Zertifikate',
        roles: 'Rollen',
        noCertificatesSelected: 'Keine Zertifikate ausgewählt',
        noRolesSelected: 'Keine Rollen ausgewählt',
        backToEdit: 'Zurück zur Bearbeitung',
        completeOnboarding: 'Onboarding abschließen',
        added: 'Hinzugefügt',
        aiAnalysis: 'KI-Analyse',
        certificate: 'Zertifikat',
        role: 'Rolle',
        other: 'Andere',
        junior: 'Junior',
        midLevel: 'Mid-Level',
        senior: 'Senior',
        expert: 'Expert',
        agentCompletionMessage:
            'Herzlichen Glückwunsch! Du hast das Onboarding erfolgreich abgeschlossen. Dein Profil wurde erstellt und dein Teamleiter wurde benachrichtigt. Willkommen im Team!',
        welcomeToTeam: 'Willkommen im Team!',
        onboardingCompleted: 'Onboarding erfolgreich abgeschlossen',
        profileCreatedNotification:
            'Ihr Profil wurde erstellt und Ihr Teamleiter wurde über Ihren erfolgreichen Abschluss informiert. Du kannst nun alle Funktionen der Skill-App nutzen.',
        onboardingResult: 'Ihr Onboarding-Ergebnis',
        superPowers: 'SuperPowers',
        teamLeaderNotified: 'Teamleiter benachrichtigt',
        teamLeaderNotificationDescription:
            'Ihr Teamleiter wurde über Ihren erfolgreichen Onboarding-Abschluss informiert und hat Zugriff auf Ihr vollständiges Profil.',
        recommendedNextSteps: 'Empfohlene nächste Schritte',
        completeProfile: 'Profil vervollständigen',
        completeProfileDescription: 'Fügen Sie weitere Details zu Ihrem Profil hinzu',
        toProfile: 'Zum Profil',
        meetTeam: 'Team kennenlernen',
        meetTeamDescription: 'Entdecken Sie Ihre Kollegen und deren Fähigkeiten',
        viewTeam: 'Team ansehen',
        exploreDashboard: 'Dashboard erkunden',
        exploreDashboardDescription: 'Nutzen Sie alle Funktionen der Skill-App',
        toDashboard: 'Zum Dashboard',
        adjustSettings: 'Einstellungen anpassen',
        adjustSettingsDescription: 'Personalisieren Sie Ihre App-Erfahrung',
        settings: 'Einstellungen',
        successInNewRole: 'Viel Erfolg in Ihrer neuen Rolle!',
    },
};
